import { z } from "zod"

export const UpdateEmailSchema = z
  .object({
    currentEmail: z.string().email({ message: "Current email is required" }),
    email: z.string().email({ message: "Email is required" }),
    confirmEmail: z.string().email({ message: "Confirm email is required!" }),
  })
  .refine((data) => data.email === data.confirmEmail, {
    message: "notMatch",
    path: ["confirmEmail"],
  })

export type UpdateEmailForm = z.infer<typeof UpdateEmailSchema>

export const UpdatePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, { message: "Current password is required!" }),
    password: z.string().min(1, { message: "Password is required!" }),
    confirmPassword: z.string().min(1, { message: "Confirm password is required!" }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "notMatch",
    path: ["confirmPassword"],
  })

export type UpdatePasswordForm = z.infer<typeof UpdatePasswordSchema>

export const UpdateCompanySchema = z.object({
  companyName: z.string().min(1, { message: "Company name is required" }),
  companyName2: z.string(),
  industry: z.string(),
  taxationID: z.string(),
  invoiceEmail: z.union([z.literal(""), z.string().email()]),
})

export type UpdateCompanyForm = z.infer<typeof UpdateCompanySchema>

export const UpdatePersonalSchema = z.object({
  title: z.string().min(1, { message: "Title is required" }),
  honorific: z.string(),
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  department: z.string(),
  phoneBusiness: z.string(),
  fax: z.string(),
  birthday: z.string(),
  preferredLanguage: z.string().min(1, { message: "Preferred language is required" }),
})

export type UpdatePersonalForm = z.infer<typeof UpdatePersonalSchema>
